import AjaxInvitationService from './ajax-invitation-service'

class VehicleModelService extends AjaxInvitationService {
  
  getList(make_id = null, code) {
    let data = make_id ? { make_id } : null 
    let headers = this.getInvitationHeader(code)
    return this.makeGetRequest('/by-invitation/models', data, headers)
  }
}

const _instance = new VehicleModelService()
export default _instance